<template>
  <div style="background-color:white">
    <!-- PRIMER CARRUSEL -->
    <section id="carouselExampleCaptions" class="carousel slide slide-full" data-ride="carousel">
        <ol class="carousel-indicators bg-carrusel01">
            <li v-for="(item, index) in listaCarrusel" :key="index" data-target="#carouselExampleCaptions" :data-slide-to="index" :class="{'active':index == 0, '':index > 0}"></li>
            <!--<li data-target="#carouselExampleCaptions" data-slide-to="1"></li>
            <li data-target="#carouselExampleCaptions" data-slide-to="2"></li>-->
        </ol>
        <div class="carousel-inner">
           
            <div v-for="(item, index) in listaCarrusel" :key="index" :class='index==0 ? "carousel-item active": "carousel-item"'>
                <div class=""></div>
                <img :src="RutaFilethumbnail+item.Imagen" class="d-block w-100" alt="ENES">
                <div class="text-conten-img">
                    <h2 class="family-01 contenido-azul color_Blanco">{{item.Texto}}</h2>
                </div>
            </div>
          
        </div>
        <a class="carousel-control-prev" href="#carouselExampleCaptions" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleCaptions" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </a>

    </section>
    <!-- TEXTO E IMAGEN -->
    <section class="seccion-01">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-12 col-sm-12 col-md-11 col-lg-10 col-xl-10">
                    <div class="row texto">
                        <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                            <h1 class="text-center mb-3 color_Azul">
                                <b>La Escuela Nacional de Estudios Superiores (ENES)</b>
                            </h1>
                            <hr class="titulo_hr">
                            <p class="mb-3">
                                Su propósito es crear y mantener en sus programas educativos un enfoque interdisciplinario con modelos innovadores y flexibles que ofrecen a sus alumnos una fuerte vinculación con la práctica. Las primeras unidades de esta Escuela se establecieron en
                                2012 en León, Guanajuato, y en Morelia, Michoacán. Dos unidades más, la ENES Mérida y la ENES Juriquilla, fueron creadas por acuerdo del H. Consejo Universitario en sus sesiones del 30 de agosto y del 13 de diciembre de
                                2017.
                            </p>
                            <router-link class="button" :to="{name:'historia'}">Ver más <i class="far fa-arrow-right"></i></router-link>
                        </div>
                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <img src="../../assets/style/images/logos/logos_enes01.png" class="d-block w-100" alt="ENES">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- IMAGEN Y CAJAS -->
    <section class="seccion-02">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 sinpadding">
                    <div class="img_index02"></div>
                </div>
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 ">
                    <div class="row justify-content-center mt-5 mb-5">
                        <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11">
                            <div class="row texto">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <h1 class="text-center mb-3 color_Azul">
                                        Nuestra oferta académica
                                    </h1>
                                    <hr class="titulo_hr">
                                </div>
                            </div>
                            <div class="row justify-content-center card-principal">
                                <div  v-for="(item, index) in listaOfertaA" :key="index" class="col-12 col-sm-12 col-md-10 col-lg-12 col-xl-12 mb-2">
                                    <router-link   v-bind:to="'/lmszc/' + item.IdLigaInteres">
                                        <div class="card  card-directorio mb-3 card_div" :style="'background-color:'+item.Color">
                                            <div class="row">
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                                                    <div class="card_Index">
                                                        <img  :src="RutaFileLigathumbnail+item.Imagen" class="imagen_card" alt="ENES ">
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
                                                    <div class="card_Index">
                                                        <div class="card_Index02">
                                                            <h5 class="mb-3">{{item.Titulo}}</h5>
                                                            <p>
                                                                <span class="mr-4">
                                                                    <img src="../../assets/style/images/iconos/ico_enes_09.png" alt="ENES">{{item.Duracion}}
                                                                </span>
                                                                <span>
                                                                    <img src="../../assets/style/images/iconos/ico_enes_10.png" alt="ENES">{{item.Sistema}}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                             
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- CARD 2X4 -->
    <section class="seccion-01">
        <div class="container texto">
            <div class="row justify-content-center">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                    <h1 class="text-center mb-3 color_Azul">
                        <b>Eventos</b>
                    </h1>
                    <hr class="titulo_hr01 mb-5">
                </div>
                <template v-for="(item, index) in listaEventos" >
                    <eventos :value="item" :rutafile="RutaFileEvento" :rutathumbnail="RutaFileEventothumbnail" :anio="anio" :key="index"></eventos>
                </template>
            
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center ">
                    <router-link class="button" :to="{name:'icalendario'}">
                        Ver calendario de eventos <i class="far fa-arrow-right"></i>
                    </router-link>
                </div>
            </div>
        </div>
    </section>
    <!-- IMAGEN W-100 -->
    <section class="seccion-01 imagen_relleno"> 
        <div class="text-conten-img-03">
            <h1 class="family-01 color_Blanco">Planta Académica de Excelencia.</h1>
            <h6 class="family-01 color_Blanco d-none d-md-block d-lg-block d-xl-block">El 100% de nuestros profesores de tiempo completo pertenecen <br> al Sistema Nacional de Investigadores</h6>
        </div>
    </section>
    <!-- CARD 3X6 -->
    <section class="seccion-01">
        <div class="container">
            <div class="row texto">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <h1 class="text-center mb-3 color_Azul ">
                        <b>Noticias y Convocatorias</b>
                    </h1>
                    <hr class="titulo_hr01 mb-5">
                </div>

                <template v-for="(item, index) in listaNoticias" >
                    <noticias :value="item" :rutathumbnail="RutaFileNoticiathumbnail" :rutafile="RutaFileNoticia" :key="index"></noticias>
                </template>

                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center ">
                     <router-link class="button" :to="{name:'inoticia'}">
                        Ver todas la noticias <i class="far fa-arrow-right"></i>
                    </router-link>
                </div>
            </div>
        </div>
    </section>
    <!-- SEGUNDO CARRUSEL -->
    <section class="seccion-01 texto">
        <h1 class="text-center mb-3 color_Azul">
            <b>Ligas de interés</b>
        </h1>
        <hr class="titulo_hr01 mb-3">
        <div id="carouselExampleIndicators" class="carousel slide slide-full" data-ride="carousel">
            <ol class="carousel-indicators margen-indicators">
                <li data-target="#carouselExampleIndicators" v-for="(item, index) in ligaInteres" :key="index" :data-slide-to="index" :class="{'active':index == 0, '':index > 0}"></li>
            </ol>
            <div class="carousel-inner">
                <div v-for="(item, index) in ligaInteres" :key="index" :class='index==0 ? "carousel-item active":"carousel-item"'>
                    <div class="row justify-content-center ">
                        <div v-for="(item2, index2) in item.Detalle" :key="index2">
                            <a @click="getWindow(item2.Link)" href="javascript:0">
                                <img :src="RutaFileLigathumbnail+item2.Imagen"  class="d-block img-fluid " alt="ENES ">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </section>
    <!-- MAPA -->
    <section class="text-center">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3725.1432885081426!2d-89.73673225104913!3d20.986892596121915!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f560c87b2bb0735%3A0x7c3a93a809085336!2sENES%20UNAM%20CAMPUS%20M%C3%89RIDA!5e0!3m2!1ses-419!2smx!4v1580769547307!5m2!1ses-419!2smx "
            width="100% " height="450 " frameborder="0 " style="border:0; " allowfullscreen=" ">
        </iframe>
    </section>
  </div>
</template>

<script>
import eventos from './modales/eventos.vue'
import noticias from './modales/noticias.vue'

export default {
    name:'',
    props:[""],
    components:{eventos,noticias},
    data() {
        return {
            listaCarrusel:[],
            listaEventos:[],
            listaNoticias:[],
            RutaFile:'',
            RutaFilethumbnail:'',
            RutaFileEvento:'',
            RutaFileEventothumbnail:'',
            RutaFileNoticia:'',
            RutaFileNoticiathumbnail:'',
            ligaInteres:[],
            RutaFileLiga: '',
            RutaFileLigathumbnail: '',
            listaOfertaA:[],
            vForLoop: 0,
            anio:'',
        }
    },
    methods: {
        get_CarruselPrincipal(){
            this.$http.get(
                'inicio/carrusel/',
                {
                    params:{ RegEstatus:'A',Tipo:'Principal',Entrada:6}
                }
            ).then( (res) => {
                this.listaCarrusel = res.data.carrusel;
                this.RutaFile = res.data.RutaFile;
                this.RutaFilethumbnail = res.data.RutaFilethumbnail;
                
            });
        },
        get_Eventos(){
            this.$http.get(
                'inicio/eventos/',
                {
                    params:{ RegEstatus:'A',Entrada:4}
                }
            ).then( (res) => {
                this.listaEventos = res.data.eventos;
                this.RutaFileEvento = res.data.RutaFile;
                this.RutaFileEventothumbnail = res.data.RutaFilethumbnail;
                this.anio = res.data.Anio;
            });
        },
        func_getData(type,data){
            var parData=data.split(" ");
            if(type=="hora"){
                return parData[1] + " "+parData[2];
            }else if(type=="dia"){
                var parDia=parData[0].split("-");
                return parDia[2];
            }else if(type=="mes"){
                var parDia=parData[0].split("-");
                return this.get_Mes(parDia[1]);
            }
        },
        get_Mes(mes){
            if(mes=="01"){ return "Enero";} else
            if(mes=="02"){ return "Febrero";}else
            if(mes=="03"){ return "Marzo";}else
            if(mes=="04"){ return "Abril";}else
            if(mes=="05"){ return "Mayo";}else
            if(mes=="06"){ return "Junio";}else
            if(mes=="07"){ return "Julio";}else
            if(mes=="08"){ return "Agosto";}else
            if(mes=="09"){ return "Septiembre";}else
            if(mes=="10"){ return "Octubre";}else
            if(mes=="11"){ return "Noviembre";}else
            {
                return "Diciembre";
            }
        },
        get_Noticias(){
            this.$http.get(
                'inicio/noticias/',
                {
                    params:{ RegEstatus:'A',Seccion:'Inicio',Entrada:6}
                }
            ).then( (res) => {
                this.listaNoticias= res.data.noticia;
                this.RutaFileNoticia = res.data.RutaFile;
                this.RutaFileNoticiathumbnail = res.data.RutaFilethumbnail;
            });
        },
        get_ligainteres(){
             this.$http.get(
                'inicio/ligainteres/',
                {
                    params:{ RegEstatus:'A',Tipo:'LigaInteres',Entrada:100}
                }
            ).then( (res) => {
                this.ligaInteres= res.data.ligainteres;
                this.RutaFileLiga = res.data.RutaFile;
                this.RutaFileLigathumbnail = res.data.RutaFilethumbnail;
                
            });
        },
        getWindow: function (adata) {   
          window.open(adata, "_blank");    
        },
        get_ListaOferta(){
             this.$http.get(
                'inicio/listaoferta/',
                {
                    params:{ RegEstatus:'A',Tipo:'lic_oferta',Entrada:100}
                }
            ).then( (res) => {
                this.listaOfertaA= res.data.ligainteres;
                this.RutaFileLiga = res.data.RutaFile;
                this.RutaFileLigathumbnail = res.data.RutaFilethumbnail;
                
            });
        },
    },
    created() {
    },
    mounted() {
        window.scrollTo(0, 0);
        this.get_CarruselPrincipal();
        this.get_Eventos();
        this.get_Noticias();
        this.get_ligainteres();
        this.get_ListaOferta();
    },
}
</script>

<style>
.modal-mask{
    background: rgba(0, 0, 0, 0.5);
}
</style>